import ApiService from "@/services/Api"

type TextEnhancementUsageResponse = {
	hasRecentUsage: boolean
}

class TextEnhancementUsageService {
	private usageChangeListeners = new Set<() => void>()

	async fetchRecentUsage (): Promise<TextEnhancementUsageResponse> {
		try {
			const { data } = await ApiService.get<TextEnhancementUsageResponse>("/settings/text-enhancement-usage")
			return data
		} catch {
			return { hasRecentUsage: false }
		}
	}

	notifyUsageDetected (): void {
		this.usageChangeListeners.forEach(listener => listener())
	}

	subscribeToUsageChange (listener: () => void): () => void {
		this.usageChangeListeners.add(listener)
		return () => {
			this.usageChangeListeners.delete(listener)
		}
	}
}

export default new TextEnhancementUsageService()
